import { Injectable } from '@angular/core';

export const CAGR_CONSTRAINTS = {
  value: { min: 1,   max: 1_000_000_000, step: 1_000 },
  years: { min: 1,   max: 50,            step: 1     }
} as const;

export interface CagrYearRow {
  year: number;
  value: number;
}

export interface CagrResult {
  cagrPercent: number;
  absoluteReturnPercent: number;
  totalGain: number;
  years: CagrYearRow[];
}

@Injectable({ providedIn: 'root' })
export class CagrCalculatorService {

  calculate(initialValue: number, finalValue: number, years: number): CagrResult {
    const cagr = Math.pow(finalValue / initialValue, 1 / years) - 1;

    const yearRows: CagrYearRow[] = [];
    for (let y = 0; y <= years; y++) {
      yearRows.push({ year: y, value: initialValue * Math.pow(1 + cagr, y) });
    }

    return {
      cagrPercent: cagr * 100,
      absoluteReturnPercent: ((finalValue - initialValue) / initialValue) * 100,
      totalGain: finalValue - initialValue,
      years: yearRows
    };
  }
}
